import React, { Component } from "react";
import "antd/dist/antd.css";
import Iconedit from "../../Images/Iconedit.png";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Upload,
  Icon,
  message,
  Table,
  Dropdown,
  Menu,
  Button,
  Modal,
  Form,
  Input,
  Spin,
  Popconfirm,
  Select,
} from "antd";
import FormItem from "antd/lib/form/FormItem";
import Docsample from "../../Images/docsample.png";
import { CloseOutlined } from "@ant-design/icons";
import Amplify, { Storage } from "aws-amplify";
import awsConfigure from "../../Config/AwsConfig";
import AppConfigs from "../../Config/AppConfig";
import { update } from "../../api/Apis";
import { formatPhoneNumber } from "../commonFunctions";
import ChangePassword from "../../Components/ChangePassword";
import LocationAutocomplete from "../../Components/Autocomplete";
import { noWhitespaceRule, notValidPhoneNumberRule } from "../../utils/Utils";
import { getUserProfile } from "../../api/userProfile";

const { Option } = Select;
Amplify.configure(awsConfigure);

function beforeUpload(file) {
  const isJpgOrPng = file.type === "image/jpeg" || file.type === "image/png";
  if (!isJpgOrPng) {
    message.error("You can only upload JPG/PNG file!");
  }
  const isLt2M = file.size / 1024 / 1024 < 2;
  if (!isLt2M) {
    message.error("Image must smaller than 2MB!");
  }
  return isJpgOrPng && isLt2M;
}

class Carriersettings extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: false,
      dataLoadingStatus: true,
      truckLoading: false,
      visible: false,
      edit: false,
      editdata: [],
      trucksDataLoading: true,
      uploadImgLoading: false,
      truckModalTitle: "",
      profilePic: "",
      userDetails: JSON.parse(localStorage.getItem("userDetails")),
      trucks: [],
      visible2: false,
      uploadProfileLoading: false,
      updateProfilePic: "",
      coi: Docsample,
      w9: Docsample,
      tandc: Docsample,
      latLangs: {},
      orgDetails: JSON.parse(localStorage.getItem("orgDetails")),
      selectedCarrierAddress: "",
    };
  }

  componentDidMount() {
    this.setState({
      dataLoadingStatus: true,
    });
    this.getOrgDetails();
  }

  getUserDetails = () => {
    this.setState({
      loading: true,
    });
    getUserProfile(this.state.userDetails.id).then(async (result) => {
      if (result.success) {
        this.setState({ userDetails: result.data });
        localStorage.setItem("userDetails", JSON.stringify(result.data));
      } else {
        console.log(result.errors);
      }
    });
    this.setState({
      loading: false,
    });
  };
  getOrgDetails = async () => {
    let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    let companyLogo = "";
    if (orgDetails["companyLogo"]) {
      companyLogo = await Storage.get(orgDetails["companyLogo"]);
    }
    let trucks = [];
    orgDetails["carrierFiles"] &&
      orgDetails["carrierFiles"]["trucks"] &&
      orgDetails["carrierFiles"]["trucks"].map((truck, index) => {
        return trucks.push({
          key: index,
          truckNumber: truck["truckNumber"],
          typeOfTruck: truck["typeOfTruck"],
        });
      });
    let profilePic = "";
    if (userDetails["profilePic"]) {
      profilePic = await Storage.get(userDetails["profilePic"]);
    }

    //documents
    let coi = Docsample,
      w9 = Docsample,
      tandc = Docsample;
    if (orgDetails["carrierFiles"] && orgDetails["carrierFiles"]["documents"]) {
      coi = await Storage.get(orgDetails["carrierFiles"]["documents"]["coi"]);
      coi = await Storage.get(orgDetails["carrierFiles"]["documents"]["w9"]);
      coi = await Storage.get(orgDetails["carrierFiles"]["documents"]["tandc"]);
    }

    this.setState({
      orgDetails: orgDetails,
      userDetails: userDetails,
      trucks: trucks,
      companyLogo: companyLogo,
      uploadImgLoading: false,
      profilePic: profilePic,
      latLangs:
        orgDetails && "latLangs" in orgDetails ? orgDetails["latLangs"] : {},
      updateProfilePic: userDetails["profilePic"],
      dataLoadingStatus: false,
      carrierInfo: orgDetails,
      coi,
      w9,
      tandc,
    });
  };

  showModal = (key) => {
    const dataSource = this.state.trucks;
    const edit = dataSource.filter((item) => item.key === key);

    this.props.form.setFieldsValue({
      typeOfTruck1: edit[0]["typeOfTruck"],
      truckNumber1: edit[0]["truckNumber"],
    });
    this.setState({
      truckModalTitle: "Edit Truck",
      edit: true,
      visible: true,
      editdata: edit,
    });
  };

  addTruck = () => {
    console.log("Enter");
    this.setState({
      visible: true,
      truckModalTitle: "Add New Truck",
    });
    this.props.form.setFieldsValue({
      typeOfTruck1: "",
      truckNumber1: "",
    });
  };

  handleOk = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(
      ["typeOfTruck1", "truckNumber1"],
      (err, values) => {
        if (!err) {
          this.setState({
            truckLoading: true,
          });
          let trucks = [];
          if (this.state.edit) {
            this.state.trucks.map((truck) => {
              if (truck["key"] === this.state.editdata[0]["key"]) {
                trucks.push({
                  truckNumber: values["truckNumber1"],
                  typeOfTruck: values["typeOfTruck1"],
                });
              } else {
                trucks.push({
                  truckNumber: truck["truckNumber"],
                  typeOfTruck: truck["typeOfTruck"],
                });
              }
              return true;
            });
            this.setState({
              editdata: [],
              edit: false,
            });
          } else {
            if ("trucks" in this.state.orgDetails["carrierFiles"]) {
              trucks = this.state.orgDetails["carrierFiles"]["trucks"];
            }
            trucks.push({
              truckNumber: values["truckNumber1"],
              typeOfTruck: values["typeOfTruck1"],
            });
            // if (this.state.orgDetails["carrierFiles"]["trucks"]) {
            //   trucks = this.state.orgDetails["carrierFiles"]["trucks"];
            // }
            // trucks.push({ "truckNumber": values["truckNumber1"], "typeOfTruck": values["typeOfTruck1"] });
          }
          let carrierFiles = {
            documents: this.state.orgDetails["carrierFiles"]["documents"],
            trucks: trucks,
          };
          let data = {
            entityData: {
              carrierFiles: carrierFiles,
            },
          };

          update(
            AppConfigs["entityNames"]["registrations"],
            this.state.orgDetails["id"],
            data
          ).then((result) => {
            if (result.success) {
              window.location.reload();
              localStorage.setItem(
                "orgDetails",
                JSON.stringify(result.data["data"])
              );
              let trucks = [];
              result.data["data"]["carrierFiles"]["trucks"].map(
                (truck, index) => {
                  return trucks.push({
                    key: index,
                    truckNumber: truck["truckNumber"],
                    typeOfTruck: truck["typeOfTruck"],
                  });
                }
              );
              this.setState({
                orgDetails: result.data["data"],
                trucks: trucks,
                edit: false,
                visible: false,
                truckLoading: false,
              });
            } else {
              console.log(result.errors);
            }
          });
        }
      }
    );
  };

  handleCancel = () => {
    // window.location.reload();
    this.setState({
      visible: false,
      edit: false,
      editdata: [],
    });
  };

  handleChange = async (fileData) => {
    this.setState({
      uploadImgLoading: true,
    });
    let file = fileData["file"]["originFileObj"];
    let userDetails = JSON.parse(localStorage.getItem("userDetails"));
    let fileName = userDetails["id"] + "_profile_pic_" + file["name"];
    await Storage.put(fileName, file, {
      contentType: file.type,
    }).then((result) => {
      let data = {};
      data["entityData"] = {};
      data["entityData"]["profilePic"] = result.key;
      update(AppConfigs["entityNames"]["users"], userDetails["id"], data).then(
        async (result) => {
          if (result.success) {
            userDetails["profilePic"] = data["entityData"]["profilePic"];
            localStorage.setItem("userDetails", JSON.stringify(userDetails));
            this.getOrgDetails();
          } else {
            this.setState({
              uploadImgLoading: false,
            });
            console.log(result.errors);
          }
        }
      );
    });
  };
  showProfileModal = () => {
    const orgData = this.state.orgDetails;
    const userData = this.state.userDetails;
    this.setState({
      visible2: true,
      selectedCarrierAddress: orgData.address,
    });
    this.props.form.setFieldsValue({
      firstName: userData.firstName,
      lastName: userData.lastName,
      phone: userData.phone,
      companyName: orgData.companyName,
      dot: orgData.dot,
      mc: orgData.mc,
      address: orgData.address,
      // "city": orgData.city,
      // "state": orgData.stateText,
      // "zip": orgData.zip,
      profilePic: orgData.profilePic,
      // "companyLogo": orgData.companyLogo
    });
    console.log(orgData);
  };
  profileHandleOk = (e) => {
    console.log(e);
    this.setState({
      visible2: false,
    });
  };

  profileHandleCancel = (e) => {
    console.log(e);
    this.setState({
      visible2: false,
    });
  };

  handleProfilePic = async (fileData) => {
    this.setState({
      uploadProfileLoading: true,
    });
    let file = fileData["file"]["originFileObj"];
    if (file) {
      let userDetails = JSON.parse(localStorage.getItem("userDetails"));
      let fileName = userDetails["id"] + "_profile_pic_" + file["name"];
      await Storage.put(fileName, file, {
        contentType: file.type,
      }).then(async (result) => {
        this.setState({
          updateProfilePic: result.key,
          profilePic: await Storage.get(result.key),
          uploadProfileLoading: false,
        });
        // data["entityData"]["profilePic"] = result.key;

        // update(AppConfigs["entityNames"]["users"], userDetails["id"], data)
        //   .then(async result => {
        //     if (result.success) {
        //       userDetails["profilePic"] = data["entityData"]["profilePic"];
        //       localStorage.setItem("userDetails", JSON.stringify(userDetails));
        //       this.getOrgDetails();
        //     } else {
        //       this.setState({
        //         uploadProfileLoading: false
        //       })
        //       console.log(result.errors);
        //     }
        //   });
      });
    } else {
      this.setState({
        uploadProfileLoading: false,
      });
    }
  };
  updateUserDetails = (e) => {
    e.preventDefault();
    this.props.form.validateFieldsAndScroll(
      ["firstName", "lastName", "phone", "companyName", "dot", "mc", "address"],
      (err, values) => {
        if (!err) {
          this.setState({
            loading: true,
          });
          console.log(values);
          let data = {};
          data["entityData"] = {};
          data["entityData"]["profilePic"] = this.state.updateProfilePic;
          data["entityData"]["firstName"] = values["firstName"];
          data["entityData"]["lastName"] = values["lastName"];
          data["entityData"]["phone"] = values["phone"];
          console.log(data);
          let userDetails = JSON.parse(localStorage.getItem("userDetails"));
          let orgDetails = JSON.parse(localStorage.getItem("orgDetails"));
          update(
            AppConfigs["entityNames"]["users"],
            userDetails["id"],
            data
          ).then(async (result) => {
            if (result.success) {
              userDetails["profilePic"] = data["entityData"]["profilePic"];
              userDetails["profilePicPath"] = await Storage.get(
                data["entityData"]["profilePic"]
              );
              userDetails["firstName"] = data["entityData"]["firstName"];
              userDetails["lastName"] = data["entityData"]["lastName"];
              localStorage.setItem("userDetails", JSON.stringify(userDetails));
              data = {};
              data["entityData"] = {};
              data["entityData"]["phone"] = values["phone"];
              data["entityData"]["companyName"] = values["companyName"];
              data["entityData"]["dot"] = values["dot"];
              data["entityData"]["mc"] = values["mc"];
              data["entityData"]["address"] = values["address"];
              data["entityData"]["latLangs"] = this.state.latLangs;
              data["entityData"]["city"] = null;
              data["entityData"]["stateText"] = null;
              data["entityData"]["zip"] = null;
              if (this.state.userDetails.userProfile !== "D") {
                update(
                  AppConfigs["entityNames"]["registrations"],
                  orgDetails["id"],
                  data
                ).then(async (result) => {
                  if (result.success) {
                    orgDetails = result["data"]["data"];
                    // orgDetails["companyLogo"] = data["entityData"]["companyLogo"];
                    localStorage.setItem(
                      "orgDetails",
                      JSON.stringify(orgDetails)
                    );
                    // this.setState({
                    //   loading: false,
                    //   visible2: false,
                    // });
                    // this.getOrgDetails();
                    // this.getUserDetails();
                    window.location.reload();
                  } else {
                    this.setState({
                      loading: false,
                    });
                    console.log(result.errors);
                  }
                });
              } else {
                this.setState({
                  loading: false,
                  visible2: false,
                });
                this.getUserDetails();
              }
            } else {
              this.setState({
                loading: false,
              });
              console.log(result.errors);
            }
          });
        }
      }
    );
  };
  handleDelete = (key) => {
    const dataSource = [...this.state.trucks];
    this.setState({
      trucks: dataSource.filter((item) => item.key !== key),
    });
    console.log(dataSource);
  };
  fileDownload = async (fileName, downloadFileName, companyName) => {
    let savedFileName = downloadFileName + "_" + companyName.replace(/ /g, "");
    this.setState({
      dataLoadingStatus: true,
    });
    Storage.get(fileName, { download: true }).then((res) =>
      this.downloadBlob(res.Body, savedFileName)
    );
  };

  getAddress = (address, latLng, fieldId) => {
    this.props.form.setFieldsValue({
      [fieldId]: address,
    });
    let latLangs = this.state.latLangs;
    this.setState({
      latLangs,
    });
  };

  downloadBlob(blob, filename) {
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;
    a.download = filename || "download";
    const clickHandler = () => {
      setTimeout(() => {
        URL.revokeObjectURL(url);
        a.removeEventListener("click", clickHandler);
      }, 150);
    };
    a.addEventListener("click", clickHandler, false);
    a.click();
    this.setState({
      dataLoadingStatus: false,
    });
    return a;
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const { visible, visible2 } = this.state;
    const uploadButton = (
      <div>
        <Icon
          style={{ fontSize: "30px", color: "#A2AABD" }}
          type={this.state.loading ? "loading" : "user"}
        />
      </div>
    );
    const imageUrl = this.state.profilePic;

    const columns = [
      {
        title: "Truck Type",
        dataIndex: "typeOfTruck",
        key: "typeOfTruck",
      },
      {
        title: "Truck Number",
        dataIndex: "truckNumber",
        key: "truckNumber",
      },

      {
        title: "",
        key: "id",
        render: (text, record) => (
          <Dropdown.Button
            overlay={
              <Menu>
                <Menu.Item className="blue">
                  <Button
                    className="modalButton"
                    onClick={() => this.showModal(record.key)}
                  >
                    Edit
                  </Button>
                </Menu.Item>
                <Menu.Item className="blue">
                  <Popconfirm
                    title="Sure to delete?"
                    onConfirm={() => this.handleDelete(record.key)}
                  >
                    <Button className="modalButton">Delete</Button>
                  </Popconfirm>
                </Menu.Item>
              </Menu>
            }
          ></Dropdown.Button>
        ),
      },
    ];

    return (
      <div className="settings">
        <Spin spinning={this.state.dataLoadingStatus}>
          <Row style={{ padding: "50px 7%  50px 7%" }}>
            <Col lg={8} md={8} sm={24} xs={24}>
              <div
                style={{
                  margin: "10px",
                  padding: "20px",
                  backgroundColor: "white",
                  borderRadius: "2%",
                }}
              >
                <Row
                  style={{
                    borderBottom: "1px solid rgb(123 129 144 / 17%)",
                    paddingBottom: "10px",
                  }}
                >
                  <Col lg={12} md={12} sm={24} xs={24}>
                    <h4 className="Companyheadinglabel">Profile</h4>
                  </Col>
                  <Col
                    lg={12}
                    md={12}
                    sm={24}
                    xs={24}
                    style={{ textAlign: "right" }}
                  >
                    {/* {!this.state.orgDetails["isActive"] && <span onClick={this.showProfileModal} style={{ color: 'red', cursor: 'pointer', textDecoration: 'underline', textAlign: 'right' }}><img src={Iconedit} alt={"Edit"} /></span>} */}
                    <span
                      onClick={this.showProfileModal}
                      style={{
                        color: "red",
                        cursor: "pointer",
                        textDecoration: "underline",
                        textAlign: "right",
                      }}
                    >
                      <img src={Iconedit} alt={"Edit"} />
                    </span>
                  </Col>
                </Row>
                <Col lg={24} md={24} sm={24} xs={24}>
                  <div style={{ textAlign: "center" }}>
                    {/* {imageUrl ? <img src={imageUrl} alt="avatar" style={{ width: '120px', height: '120px', borderRadius: '50%', marginTop: '2%', marginLeft: '143px' }} /> : <div style={{ width: '80px', height: '80px', borderRadius: '50%', marginTop: '2%', marginLeft: '160px', paddingLeft: "4px", border: "1px solid #A2AABD" }}><Icon style={{ fontSize: '70px', color: '#A2AABD' }} type={'user'} /></div>} */}
                    {imageUrl ? (
                      <img
                        src={imageUrl}
                        alt="avatar"
                        style={{
                          width: "110px",
                          height: "110px",
                          borderRadius: "50%",
                          marginTop: "2%",
                        }}
                      />
                    ) : (
                      <div>
                        <Icon
                          style={{
                            fontSize: "70px",
                            color: "#A2AABD",
                            marginTop: "15%",
                          }}
                          type={"user"}
                        />
                      </div>
                    )}
                  </div>
                  {/* <img src={imageUrl} alt="avatar" style={{ width: '30%', borderRadius: '50%', marginTop: '2%', marginLeft: '130px' }} /> */}
                  {/* <Spin spinning={this.state.uploadImgLoading}>
              <Upload
                name="avatar"
                listType="picture-card"
                className="avatar-uploader"
                style={{ borderRadius: '50%' }}
                showUploadList={false}
                // action="https://www.mocky.io/v2/5cc8019d300000980a055e76"
                beforeUpload={beforeUpload}
                onChange={this.handleChange}
              >
                {imageUrl ? <img src={imageUrl} alt="avatar" style={{ width: '100%', borderRadius: '50%' }} /> : uploadButton}
              </Upload>
              </Spin> */}
                  <h5
                    style={{
                      color: "black",
                      fontSize: "20px",
                      textAlign: "center",
                      marginTop: "10px",
                      marginBottom: "0px",
                    }}
                  >
                    {this.state.userDetails["firstName"] +
                      " " +
                      this.state.userDetails["lastName"]}
                  </h5>
                  <h5
                    style={{
                      color: "#1A5EB9",
                      fontSize: "17px",
                      textAlign: "center",
                      marginBottom: "0px",
                    }}
                  >
                    {this.state.userDetails["email"]}
                  </h5>
                  <h5
                    style={{
                      color: "#24405E",
                      fontSize: "17px",
                      textAlign: "center",
                      paddingBottom: "10px",
                      borderBottom: "1px solid rgb(123 129 144 / 17%)",
                    }}
                  >
                    {formatPhoneNumber(this.state.userDetails["phone"])}
                  </h5>
                </Col>
                {/* {this.state.userDetails.userProfile !== "D" && ( */}
                {this.state.userDetails.userProfile !== "D" && (
                  <Row>
                    <Col lg={12} md={12} sm={24} xs={24}>
                      <h4
                        style={{
                          color: "#7B8190",
                          fontSize: "13px",
                          marginTop: "20px",
                        }}
                      >
                        DOT#
                      </h4>
                      <h2 style={{ color: "black", fontSize: "15px" }}>
                        {this.state.orgDetails["dot"]}
                      </h2>
                    </Col>
                    <Col lg={12} md={12} sm={24} xs={24}>
                      <h4
                        style={{
                          color: "#7B8190",
                          fontSize: "13px",
                          marginTop: "20px",
                        }}
                      >
                        MC#
                      </h4>
                      <h2 style={{ color: "black", fontSize: "15px" }}>
                        {this.state.orgDetails["mc"]}
                      </h2>
                    </Col>
                  </Row>
                )}
                <h4
                  style={{
                    color: "#7B8190",
                    fontSize: "13px",
                    marginTop: "20px",
                  }}
                >
                  Company Name
                </h4>
                <h2 style={{ color: "black", fontSize: "15px" }}>
                  {this.state.orgDetails["companyName"]}
                </h2>
                <h4
                  style={{
                    color: "#7B8190",
                    fontSize: "13px",
                    marginTop: "20px",
                  }}
                >
                  Company Email
                </h4>
                <h2 style={{ color: "#1A5EB9", fontSize: "15px" }}>
                  {this.state.orgDetails["email"]}
                </h2>
                <h4
                  style={{
                    color: "#7B8190",
                    fontSize: "13px",
                    marginTop: "20px",
                  }}
                >
                  Address
                </h4>
                <h2 style={{ color: "black", fontSize: "15px" }}>
                  {this.state.orgDetails["address"]}
                </h2>

                {/* )} */}
              </div>
            </Col>
            {this.state.userDetails.userProfile === "CA" && (
            <Col lg={9} md={9} sm={24} xs={24}>
              <div
                style={{
                  margin: "10px",
                  padding: "20px",
                  backgroundColor: "white",
                  borderRadius: "2%",
                }}
              >
                <Row
                  style={{
                    borderBottom: "1px solid rgb(123 129 144 / 17%)",
                    paddingBottom: "10px",
                  }}
                >
                  <Col lg={12} md={12} sm={24} xs={24}>
                    <h4 className="Companyheadinglabel">Trucks</h4>
                  </Col>
                  <Col
                    lg={12}
                    md={12}
                    sm={24}
                    xs={24}
                    style={{ textAlign: "right" }}
                  >
                    <span onClick={this.addTruck} style={{ cursor: "pointer" }}>
                      <Button
                        type="dashed"
                        style={{
                          textAlign: "center",
                          backgroundColor: "#0E4D90",
                          width: "20px",
                          borderRadius: "50%",
                          borderColor: "#0E4D90",
                          padding: "0px",
                          height: "20px",
                        }}
                      >
                        <Icon
                          type="plus"
                          style={{
                            verticalAlign: "0px",
                            fontSize: "12px",
                            color: "white",
                          }}
                        />
                      </Button>
                      &nbsp;<span>Add Truck</span>
                    </span>
                  </Col>
                </Row>
                <div className="trucktable">
                  <div
                    className="orders"
                    style={{
                      padding: "0px",
                      margin: "0px",
                      paddingTop: "25px",
                    }}
                  >
                    <Table
                      columns={columns}
                      dataSource={this.state.trucks}
                      pagination={false}
                      // loading={this.state.trucksDataLoading}
                      // rowKey={record => record.fieldtext.key}
                      // onChange={this.handleChange}
                      // size="small"
                    />
                  </div>
                </div>
              </div>
            </Col>
            )}
            {this.state.userDetails.userProfile === "CA" && (
              <Col lg={7} md={7} sm={24} xs={24}>
                <div
                  style={{
                    margin: "10px",
                    padding: "20px",
                    backgroundColor: "white",
                    borderRadius: "2%",
                  }}
                >
                  <Row
                    style={{
                      borderBottom: "1px solid rgb(123 129 144 / 17%)",
                      paddingBottom: "10px",
                    }}
                  >
                    <Col lg={12} md={12} sm={24} xs={24}>
                      <h4 className="Companyheadinglabel">Documents</h4>
                    </Col>
                    <Col
                      lg={12}
                      md={12}
                      sm={24}
                      xs={24}
                      style={{ textAlign: "right" }}
                    >
                      {/* {!this.state.orgDetails["isActive"] && <Link to="/carrier_app/editdocuments" style={{ cursor: "pointer" }}><img src={Iconedit} alt="Edit" /></Link>} */}
                      {this.state.carrierInfo &&
                        this.state.carrierInfo["carrierFiles"] &&
                        this.state.carrierInfo["carrierFiles"]["documents"] && (
                          <Link
                            to="/carrier_app/editdocuments"
                            style={{ cursor: "pointer" }}
                          >
                            <img src={Iconedit} alt="Edit" />
                          </Link>
                        )}
                    </Col>
                  </Row>
                  {/* <Row style={{ textAlign: 'center', paddingTop: '20px' }}>
                <Col lg={8} md={8} sm={24} xs={24}>
                  <img src={Docsample} alt="Doc" />
                  <h4 style={{ color: '#7B8190', fontSize: '13px' }}>Credit App</h4>
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                  <img src={Docsample} alt="Doc" />
                  <h4 style={{ color: '#7B8190', fontSize: '13px' }}>Credit App</h4>
                </Col>
                <Col lg={8} md={8} sm={24} xs={24}>
                  <img src={Docsample} alt="Doc" />
                  <h4 style={{ color: '#7B8190', fontSize: '13px' }}>Credit App</h4>
                </Col>
              </Row> */}

                  <Row style={{ textAlign: "center", paddingTop: "20px" }}>
                    {this.state.carrierInfo &&
                      this.state.carrierInfo["carrierFiles"] &&
                      this.state.carrierInfo["carrierFiles"]["documents"] &&
                      this.state.carrierInfo["carrierFiles"]["documents"]["coi"]
                        .length > 0 && (
                        <Col lg={8} md={8} sm={24} xs={24}>
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              this.fileDownload(
                                this.state.carrierInfo["carrierFiles"][
                                  "documents"
                                ]["coi"][0],
                                "COI",
                                this.state.carrierInfo["companyName"]
                              );
                            }}
                          >
                            <img src={Docsample} alt="Doc" />
                            <h4
                              style={{
                                color: "#7B8190",
                                fontSize: "13px",
                                textAlign: "center",
                              }}
                            >
                              COI
                            </h4>
                          </span>
                        </Col>
                      )}
                    {this.state.carrierInfo &&
                      this.state.carrierInfo["carrierFiles"] &&
                      this.state.carrierInfo["carrierFiles"]["documents"] &&
                      this.state.carrierInfo["carrierFiles"]["documents"]["w9"]
                        .length > 0 && (
                        <Col lg={8} md={8} sm={24} xs={24}>
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              this.fileDownload(
                                this.state.carrierInfo["carrierFiles"][
                                  "documents"
                                ]["w9"][0],
                                "W9",
                                this.state.carrierInfo["companyName"]
                              );
                            }}
                          >
                            <img src={Docsample} alt="Doc" />
                            <h4
                              style={{
                                color: "#7B8190",
                                fontSize: "13px",
                                textAlign: "center",
                              }}
                            >
                              W-9
                            </h4>
                          </span>
                        </Col>
                      )}
                    {/* {
                    this.state.carrierInfo && this.state.carrierInfo["carrierFiles"] && this.state.carrierInfo["carrierFiles"]["documents"] && this.state.carrierInfo["carrierFiles"]["documents"]["tandc"].length > 0 &&
                    <Col lg={8} md={8} sm={24} xs={24}>
                      <span>
                        <img src={Docsample} alt="Doc" />
                        <h4 style={{ color: '#7B8190', fontSize: '13px', textAlign: 'center' }}>Agreement</h4>
                      </span>
                    </Col>
                  } */}
                    {this.state.carrierInfo &&
                      this.state.carrierInfo["carrierFiles"] &&
                      this.state.carrierInfo["carrierFiles"]["documents"] &&
                      this.state.carrierInfo["carrierFiles"]["documents"]["nda"]
                        .length > 0 && (
                        <Col lg={8} md={8} sm={24} xs={24}>
                          <span
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              this.fileDownload(
                                this.state.carrierInfo["carrierFiles"][
                                  "documents"
                                ]["nda"][0],
                                "NDA",
                                this.state.carrierInfo["companyName"]
                              );
                            }}
                          >
                            <img src={Docsample} alt="Doc" />
                            <h4
                              style={{
                                color: "#7B8190",
                                fontSize: "13px",
                                textAlign: "center",
                              }}
                            >
                              NDA
                            </h4>
                          </span>
                        </Col>
                      )}
                  </Row>
                </div>
              </Col>
            )}
                        <Col lg={7} md={7} sm={24} xs={24}>
                <div
                  style={{
                    margin: "10px",
                    padding: "20px",
                    backgroundColor: "white",
                    borderRadius: "2%",
                  }}
                >
                  <Row
                    style={{
                      borderBottom: "1px solid rgb(123 129 144 / 17%)",
                      paddingBottom: "10px",
                    }}
                  >
                    <Col lg={12} md={12} sm={24} xs={24}>
                      <h4 className="Companyheadinglabel">Security</h4>
                    </Col>
                  </Row>
                  <Row style={{ textAlign: "center", paddingTop: "20px" }}>
                    <Col lg={8} md={8} sm={24} xs={24}>
                      <ChangePassword />
                    </Col>
                  </Row>
                </div>
              </Col>
          </Row>
            <Form>
              <Modal
                visible={visible2}
                // onOk={this.profileHandleOk}
                // onCancel={this.profileHandleCancel}
                closable={true}
                footer={[
                  <Button
                    key="submit"
                    className="cancel"
                    onClick={this.profileHandleCancel}
                  >
                    Cancel
                  </Button>,
                  <Button
                    type="primary"
                    key="editSubmit"
                    htmlType="submit"
                    loading={this.state.loading}
                    onClick={this.updateUserDetails}
                  >
                    Update
                  </Button>,
                ]}
              >
                <CloseOutlined
                  onClick={this.profileHandleCancel}
                  style={{
                    float: "right",
                    cursor: "pointer",
                    fontSize: "1.4em",
                  }}
                />

                <div style={{ marginTop: "10%" }}>
                  <h1 style={{ textAlign: "center" }}>Edit Profile</h1>
                  <Row gutter={10}>
                    <Col lg={12} md={12} sm={24} xs={24}>
                      <Form.Item
                        className="Formitem"
                        label={
                          <span style={{ color: "#0E4D90" }}>First Name</span>
                        }
                      >
                        {getFieldDecorator("firstName", {
                          initialValue: "",
                          rules: [
                            {
                              required: true,
                              message: "Please input your First Name",
                            },
                            noWhitespaceRule,
                          ],
                        })(<Input />)}
                      </Form.Item>
                    </Col>
                    <Col lg={12} md={12} sm={24} xs={24}>
                      <Form.Item
                        className="Formitem"
                        label={
                          <span style={{ color: "#0E4D90" }}>Last Name</span>
                        }
                      >
                        {getFieldDecorator("lastName", {
                          initialValue: "",
                          rules: [
                            {
                              required: true,
                              message: "Please input your Last Name",
                            },
                            noWhitespaceRule,
                          ],
                        })(<Input />)}
                      </Form.Item>
                    </Col>
                    <Col lg={12} md={12} sm={24} xs={24}>
                      <Form.Item
                        className="Formitem"
                        label={
                          <span style={{ color: "#0E4D90" }}>
                            Mobile Number
                          </span>
                        }
                      >
                        {getFieldDecorator("phone", {
                          initialValue: "",
                          rules: [
                            {
                              required: true,
                              message: "Please input your Mobile Number",
                            },
                            noWhitespaceRule,
                            notValidPhoneNumberRule,
                          ],
                        })(<Input />)}
                      </Form.Item>
                    </Col>
                    {this.state.userDetails.userProfile !== "D" && (
                      <>
                        <Col lg={12} md={12} sm={24} xs={24}>
                          <Form.Item
                            className="Formitem"
                            label={
                              <span style={{ color: "#0E4D90" }}>
                                Company Name
                              </span>
                            }
                          >
                            {getFieldDecorator("companyName", {
                              initialValue: "",
                              rules: [
                                {
                                  required: true,
                                  message: "Please input your Company Name",
                                },
                                noWhitespaceRule,
                              ],
                            })(<Input />)}
                          </Form.Item>
                        </Col>
                        <Col lg={12} md={12} sm={24} xs={24}>
                          <Form.Item
                            className="Formitem"
                            label={
                              <span style={{ color: "#0E4D90" }}>DOT#</span>
                            }
                          >
                            {getFieldDecorator("dot", {
                              initialValue: "",
                              rules: [
                                {
                                  required: true,
                                  message: "Please input your DOT#",
                                },
                                noWhitespaceRule,
                              ],
                            })(<Input />)}
                          </Form.Item>
                        </Col>
                        <Col lg={12} md={12} sm={24} xs={24}>
                          <Form.Item
                            className="Formitem"
                            label={
                              <span style={{ color: "#0E4D90" }}>MC#</span>
                            }
                          >
                            {getFieldDecorator("mc", {
                              initialValue: "",
                              rules: [
                                {
                                  required: true,
                                  message: "Please input your MC#",
                                },
                                noWhitespaceRule,
                              ],
                            })(<Input />)}
                          </Form.Item>
                        </Col>

                        <Col lg={24} md={24} sm={24} xs={24}>
                          <Form.Item
                            className="Formitem"
                            label={
                              <span style={{ color: "#0E4D90" }}>Address</span>
                            }
                          >
                            {getFieldDecorator("address", {
                              initialValue: "",
                              rules: [
                                {
                                  required: true,
                                  message: "Please input your Address",
                                },
                              ],
                            })(
                              <LocationAutocomplete
                                getAddress={(address, latLng) =>
                                  this.getAddress(address, latLng, "address")
                                }
                                editMode={true}
                                address={this.state.selectedCarrierAddress}
                                setAddress={(address) => {
                                  this.setState({
                                    selectedCarrierAddress: address,
                                  });
                                }}
                              />
                            )}
                          </Form.Item>
                        </Col>
                      </>
                    )}
                    {/* <Col lg={24} md={24} sm={24} xs={24}>
                      <Form.Item className="Formitem"
                        label={<span style={{ color: '#0E4D90' }}>City</span>} >
                        {getFieldDecorator('city', {
                          initialValue: '',
                          rules: [{ required: true, message: 'Please input your City' }],
                        })(<Input />)}
                      </Form.Item>
                    </Col>
                    <Col lg={12} md={12} sm={24} xs={24}>
                      <Form.Item className="Formitem"
                        label={<span style={{ color: '#0E4D90' }}>State</span>} >
                        {getFieldDecorator('state', {
                          initialValue: '',
                          rules: [{ required: true, message: 'Please input your State' }],
                        })(<Input />)}
                      </Form.Item>
                    </Col>
                    <Col lg={12} md={12} sm={24} xs={24}>
                      <Form.Item className="Formitem" style={{ width: '97.5%' }}
                        label={<span style={{ color: '#0E4D90' }}>Pincode</span>}>
                        {getFieldDecorator('zip', {
                          rules: [{ required: true, message: 'Please input your PO' }],
                        })(<Input />)}
                      </Form.Item>
                    </Col> */}
                    <Col
                      lg={12}
                      md={12}
                      sm={24}
                      xs={24}
                      style={{ margin: "auto" }}
                    >
                      <Form.Item
                        label={
                          <span style={{ color: "#0E4D90" }}>
                            Profile Picture
                          </span>
                        }
                      >
                        {getFieldDecorator("profilePic", {
                          // rules: [{ required: true, message: 'Please upload Image!' }],
                        })(
                          <Spin spinning={this.state.uploadProfileLoading}>
                            <Upload
                              name="avatar"
                              listType="picture-card"
                              className="avatar-uploader"
                              style={{ borderRadius: "50%" }}
                              showUploadList={false}
                              beforeUpload={beforeUpload}
                              onChange={this.handleProfilePic}
                            >
                              {imageUrl ? (
                                <img
                                  src={imageUrl}
                                  alt="avatar"
                                  style={{
                                    width: "90px",
                                    height: "90px",
                                    borderRadius: "50%",
                                  }}
                                />
                              ) : (
                                uploadButton
                              )}
                            </Upload>
                          </Spin>
                        )}
                      </Form.Item>
                    </Col>
                    {/* <Col lg={12} md={12} sm={24} xs={24} style={{ margin: 'auto' }}>
                <Form.Item
                  label={<span style={{ color: '#0E4D90' }}>Company Logo</span>}>
                  {getFieldDecorator('companyLogo', {
                  })(
                   
                    <Spin spinning={this.state.uploadImgLoading}>
                      <Upload
                      name="avatar"
                      listType="picture-card"
                      className="avatar-uploader"
                      style={{ borderRadius: '50%' }}
                      showUploadList={false}
                      beforeUpload={beforeUpload}
                      onChange={this.handleChange}
                    >
                      {companyLogo ? <img src={companyLogo} alt="avatar" style={{ width: '100%', borderRadius: '50%' }} /> : uploadButton}
                    </Upload>
                    </Spin>
                  )}
                </Form.Item>

              </Col> */}
                  </Row>
                </div>
              </Modal>
            </Form>
            <Form>
              <Modal
                visible={visible}
                title={this.state.truckModalTitle}
                onOk={this.handleOk}
                onCancel={this.handleCancel}
                footer={[
                  <Button
                    key="back"
                    className="cancel"
                    onClick={this.handleCancel}
                  >
                    Cancel
                  </Button>,
                  <Button
                    key="submit"
                    className="assigning"
                    loading={this.state.truckLoading}
                    onClick={this.handleOk}
                  >
                    Save
                  </Button>,
                ]}
              >
                <FormItem>
                  <CloseOutlined
                    onClick={this.handleCancel}
                    style={{
                      float: "right",
                      cursor: "pointer",
                      fontSize: "1.4em",
                    }}
                  />
                  <div style={{ marginTop: "7%" }}>
                    <Row>
                      <Col lg={24} md={24} sm={24} sx={24}>
                        <Form.Item
                          className="Formitem"
                          label={
                            <span style={{ color: "#0E4D90" }}>
                              Type of Truck
                            </span>
                          }
                        >
                          {getFieldDecorator("typeOfTruck1", {
                            initialValue: "",
                            rules: [
                              {
                                required: true,
                                message: "Please input your Type of Truck",
                              },
                            ],
                          })(
                            <Select
                              notFoundContent={"Not found?!"}
                              placeholder="Delivery Truck"
                              // onChange={(value) => this.setState({ deliveryTruck: value })}
                              style={{ width: "100%" }}
                            >
                              <Option value="Tractor Trailer">
                                Tractor Trailer
                              </Option>
                              <Option value="Dump Truck/Triaxle">
                                Dump Truck/Triaxle
                              </Option>
                              <Option value="Mason Dump">Mason Dump</Option>
                              <Option value="Flatbed with forklift">
                                Flatbed with forklift
                              </Option>
                              <Option value="Flatbed">Flatbed</Option>
                            </Select>
                          )}
                        </Form.Item>
                      </Col>
                      <Col lg={24} md={24} sm={24} sx={24}>
                        <Form.Item
                          className="Formitem"
                          label={
                            <span style={{ color: "#0E4D90" }}>
                              Truck number
                            </span>
                          }
                        >
                          {getFieldDecorator("truckNumber1", {
                            initialValue: "",
                            rules: [
                              {
                                required: true,
                                message: "Please input your Truck Number",
                              },
                            ],
                          })(<Input />)}
                        </Form.Item>
                      </Col>
                    </Row>
                  </div>
                </FormItem>
              </Modal>
            </Form>
        </Spin>
      </div>
    );
  }
}
export default Form.create({ name: "Carriersettings" })(Carriersettings);
